/* eslint-disable i18next/no-literal-string */
import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error?: [Error, unknown];
}

/**
 * Component that renders an error page if an error occurs.
 */
export class ErrorBoundary extends Component<Props, State> {
  render() {
    const err = this.state?.error;
    if (!err) {
      return this.props.children;
    }

    return (
      <div>
        <h1>Whoops</h1>
        <p>Something went wrong.</p>

        <button onClick={() => window.location.reload()}>Reload</button>
      </div>
    );
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    this.setState({ error: [error, errorInfo] });
  }
}
